import CustomerPage from "@/components/CustomerPage";
import CustomerTabs from "@/components/CustomerTabs";
import Questionnaire from "@/components/Questionnaire";
import QuestionnaireReport, { useQuestionnaireReport } from "@/components/QuestionnaireReport";
import B2CHeader from "@/tpo/header/B2CHeader";

import {
  CREATE_USER_SUBMISSION_MUTATION,
  QUESTIONNAIRE_QUERY,
  SUBMIT_USER_ANSWER_MUTATION,
  SUBMIT_USER_QUESTIONNAIRE_MUTATION,
  USER_QUESTIONNAIRE_REPORT_QUERY
} from "./graphql/query";

export default function CustomQuestionnaire() {
  const { hasReport, report, loading, showReportView, handleContinue, handleRetake } =
    useQuestionnaireReport(USER_QUESTIONNAIRE_REPORT_QUERY, {
      createSubmissionMutation: CREATE_USER_SUBMISSION_MUTATION
    });

  return (
    <>
      <B2CHeader />
      <CustomerPage
        jumbotronProps={{
          title: "Questionnaire"
        }}
        bg="haze"
      >
        <CustomerTabs selectedTab="/questionnaire" />
        {showReportView ? (
          <QuestionnaireReport report={report} onRetake={handleRetake} />
        ) : (
          !loading && (
            <Questionnaire
              QUESTIONNAIRE_QUERY={QUESTIONNAIRE_QUERY}
              SUBMIT_USER_ANSWER_MUTATION={SUBMIT_USER_ANSWER_MUTATION}
              SUBMIT_USER_QUESTIONNAIRE_MUTATION={SUBMIT_USER_QUESTIONNAIRE_MUTATION}
              CREATE_USER_SUBMISSION_MUTATION={CREATE_USER_SUBMISSION_MUTATION}
              onContinue={handleContinue}
              showFinishLaterButton={hasReport}
            />
          )
        )}
      </CustomerPage>
    </>
  );
}
